/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeGoCampaign_Precincts.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   GoCampaign Precinct Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, October 27, 2019 - 01:52:36 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      10/27/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const PRECINCT_LIST_CONTAINER_LOADED = 'PRECINCT_LIST_CONTAINER_LOADED';
export const PRECINCT_LIST_CONTAINER_UNLOADED = 'PRECINCT_LIST_CONTAINER_UNLOADED';
export const PRECINCT_LIST_TABLE_LOADED = 'PRECINCT_LIST_TABLE_LOADED';
export const PRECINCT_LIST_TABLE_UNLOADED = 'PRECINCT_LIST_TABLE_UNLOADED';

export const PRECINCT_LIST_CHANGE_GROUP = 'PRECINCT_LIST_CHANGE_GROUP';
export const PRECINCT_SELECT_ROW = 'PRECINCT_SELECT_ROW';

export const PRECINCT_ADD = 'PRECINCT_ADD';
export const PRECINCT_EDIT = 'PRECINCT_EDIT';
export const PRECINCT_DELETE = 'PRECINCT_DELETE';
export const PRECINCT_OPEN_WARNING = 'PRECINCT_OPEN_WARNING';
export const PRECINCT_CLOSE_WARNING = 'PRECINCT_CLOSE_WARNING';
export const PRECINCT_DELETE_DISABLE = 'PRECINCT_DELETE_DISABLE';
export const PRECINCT_VIEW_CHILD_ITEMS = 'PRECINCT_VIEW_CHILD_ITEMS';

export const PRECINCT_EDIT_CONTAINER_LOADED = 'PRECINCT_EDIT_CONTAINER_LOADED';
export const PRECINCT_EDIT_CONTAINER_UNLOADED = 'PRECINCT_EDIT_CONTAINER_UNLOADED';
export const PRECINCT_EDIT_FORM_LOADED = 'PRECINCT_EDIT_FORM_LOADED';
export const PRECINCT_EDIT_FORM_UNLOADED = 'PRECINCT_EDIT_FORM_UNLOADED';

export const PRECINCT_SET_GROUP_SELECT = 'PRECINCT_SET_GROUP_SELECT';
export const PRECINCT_EDIT_DATA_LOAD = 'PRECINCT_EDIT_DATA_LOAD';

export const PRECINCT_EDIT_CONTAINER_SUBMIT = 'PRECINCT_EDIT_CONTAINER_SUBMIT';
export const PRECINCT_EDIT_CONTAINER_CANCEL = 'PRECINCT_EDIT_CONTAINER_CANCEL';

export const PRECINCT_UPDATE_VALUE = 'PRECINCT_UPDATE_VALUE';


// WEBPACK FOOTER //
// ./src/constants/actionTypeGoCampaign_Precincts.js